<template>
  <div class="productos-por-operario">
    <!-- Migas -->
    <nav aria-label="breadcrumb" class="mb-3">
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><router-link :to="{ name: 'home' }">{{ $t('inicio') }}</router-link></li>
        <li class="breadcrumb-item"><router-link :to="{ name: 'informes' }">{{ $t('informes') }}</router-link></li>
        <li class="breadcrumb-item"><router-link :to="{ name: 'ventas-productos' }"> {{$t("ventaDeProductosPorNegocio")}}</router-link></li>
        <li class="breadcrumb-item active">{{ $t('listadoDeProductosPorOperario') }}</li>
      </ol>
    </nav>

    <!-- Info producto -->
    <div class="mb-3">
    <h4>
    {{ $t('producto') }}:
    <span class="text-primary">{{ productName || '—' }}</span>
    </h4>


    </div>

    <!-- Tabla -->
    <div v-if="rows.length" class="table-responsive">
      <table class="table table-bordered table-striped">
        <thead class="thead-dark">
          <tr>
            <th>{{ $t('operario') }}</th>
            <th class="text-right">{{ $t('cuentas') }}</th>
            <th class="text-right">{{ $t('cantidad') }}</th>
            <th class="text-right">{{ $t('importe') }}</th>
            <th class="text-right">{{ $t('importeSinIva') }}</th>
            <th class="text-right">{{ $t('precioMed') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="r in rows" :key="(r.operarioId || r.operario) + ''">
            <td>{{ r.operario }}</td>
            <td class="text-right">{{ r.cuentas }}</td>
            <td class="text-right">{{ r.cantidad }}</td>
            <td class="text-right">{{ r.importe | currency }}</td>
            <td class="text-right">{{ r.importeSinIva | currency }}</td>
            <td class="text-right">{{ calcPrecioMedio(r) | currency }}</td>
          </tr>
        </tbody>
        <tfoot>
          <tr class="table-success">
            <td><strong>{{ $t('total') }}</strong></td>
            <td class="text-right"><strong>{{ totalCuentas }}</strong></td>
            <td class="text-right"><strong>{{ totalCantidad }}</strong></td>
            <td class="text-right"><strong>{{ totalImporte | currency }}</strong></td>
            <td class="text-right"><strong>{{ totalImporteSinIva | currency }}</strong></td>
            <td></td>
          </tr>
        </tfoot>
      </table>
    </div>

    <!-- Sin datos -->
    <div v-else class="alert alert-info">
      {{ $t('noHayDatosParaMostrar') || 'No hay datos para mostrar en el rango seleccionado.' }}
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { Loading } from 'element-ui'

export default {
  name: 'ProductosPorOperario',
  props: {
    idBusiness: { type: Number, required: true },
    idProducto: { type: Number, required: true } // route props -> routes.js ya lo prepara
  },
  data () {
    return {
      rows: [],
      loading: null
    }
  },
  computed: {
      productName () {
    // Lo leemos desde la query
    const q = this.$route.query || {}
    if (q.productName && typeof q.productName === 'string') {
      return q.productName.trim()
    }
    return ''
  },
    // Fallback por si alguien entra solo con query
    idProductoEfectivo () {
      const p = Number(this.idProducto || 0)
      if (p > 0) return p
      const q = Number(this.$route.query.idProducto || 0)
      return q > 0 ? q : 0
    },
    // Fechas unix desde query o por defecto (mes actual)
    datefromUnix () {
      const v = Number(this.$route.query.datefrom || 0)
      return v > 0 ? v : moment().startOf('month').unix()
    },
    datetoUnix () {
      const v = Number(this.$route.query.dateto || 0)
      return v > 0 ? v : moment().endOf('day').unix()
    },
    // TPV: acepta "1", 1 o "[1,2]"
    idTpvList () {
      const raw = this.$route.query.idTpv
      try {
        if (Array.isArray(raw)) return raw.map(n => Number(n)).filter(n => !isNaN(n))
        if (typeof raw === 'string' && raw.trim().startsWith('[')) {
          return JSON.parse(raw).map(Number).filter(n => !isNaN(n))
        }
        if (raw !== undefined && raw !== '') {
          const n = Number(raw)
          return !isNaN(n) ? [n] : []
        }
      } catch (e) {}
      return []
    },
    // Totales
    totalCuentas ()      { return this.rows.reduce((a, r) => a + (Number(r.cuentas) || 0), 0) },
    totalCantidad ()     { return this.rows.reduce((a, r) => a + (Number(r.cantidad) || 0), 0) },
    totalImporte ()      { return this.rows.reduce((a, r) => a + (Number(r.importe) || 0), 0) },
    totalImporteSinIva (){ return this.rows.reduce((a, r) => a + (Number(r.importeSinIva) || 0), 0) },
    // Top seller por importe
    topSeller () {
      if (!this.rows.length) return null
      return this.rows.slice().sort((a,b) => (Number(b.importe)||0) - (Number(a.importe)||0))[0]
    }
  },
  created () {
    this.fetchData()
  },
  watch: {
    '$route' () { this.fetchData() }
  },
  methods: {
    fetchData () {
      if (!this.idProductoEfectivo) return

      const params = {
        jwt: this.$store.getters.jwt,
        idBusiness: Number(this.idBusiness),
        idProducto: Number(this.idProductoEfectivo),
        idTpv: this.idTpvList, // ← IMPORTANTE
        datefrom: moment.unix(this.datefromUnix).startOf('day').unix(),
        dateto:   moment.unix(this.datetoUnix).endOf('day').unix()
      }

      this.loading = Loading.service({ text: this.$t('cargando') || 'Cargando...' })

      this.axios
        .get(this.$store.getters.apiUrl + 'products/getSalesProductByOperator', {
          params,
          headers: { Authorization: 'Bearer ' + this.$store.getters.jwt }
        })
        .then(res => {
          if (res && res.data && res.data.response) {
            const items = Array.isArray(res.data.result) ? res.data.result : []
            // La API ya debería venir agrupada. De todas formas, normalizamos campos y casteamos a número.
            this.rows = items.map(x => ({
              operarioId:    x.operarioId != null ? x.operarioId : (x.workerId != null ? x.workerId : null),
              operario:      x.operario    || x.workerName || '—',
              cantidad:      Number(x.cantidad) || 0,
              importe:       Number(x.importe) || 0,
              importeSinIva: Number(x.importeSinIva) || 0,
              cuentas:       Number(x.cuentas) || 0
            }))
          } else {
            this.rows = []
          }
        })
        .catch(err => {
          // eslint-disable-next-line no-console
          console.error('Error cargando productos por operario:', err)
          this.rows = []
        })
        .finally(() => { this.loading && this.loading.close() })
    },
    calcPrecioMedio (r) {
      const c = Number(r.cantidad) || 0
      return c ? (Number(r.importe) || 0) / c : 0
    }
  },
  filters: {
    currency (v) {
      return new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' }).format(Number(v) || 0)
    },
    humanDate (v) { return moment.unix(Number(v) || 0).startOf('day').format('LL') },
    humanDateEnd (v) { return moment.unix(Number(v) || 0).endOf('day').format('LL') }
  }
}
</script>

<style scoped>
.table-responsive { margin-top: 10px; }
</style>



// WEBPACK FOOTER //
// src/pages/Dashboard/Informes/Productos/ProductosPorOperario.vue